export default {
    convertKmToMiles(kilometers) {
        if (kilometers === 0) {
            return 0;
        }

        if (!kilometers || kilometers === null) {
            return null;
        }
        return +(kilometers * 0.621371).toFixed();
    },
    convertMilesToKm(miles) {
        if (miles === 0) {
            return 0;
        }

        if (!miles || miles === null) {
            return null;
        }
        return +(miles * 1.60934).toFixed();
    },

    // Return a random number between min and max
    randomBetween(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
};
